var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 74,
    viewBox: "0 0 92 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_30535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92 36.5L78.5 13L48.5 7L34 33.5L14.5 48L0 74.8267",
    stroke: "#F64C4C",
    strokeWidth: 1.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 13L92 35.5L92.6133 74.8267H0L15 48L34 33L48.5 7L78.5 13Z",
    fill: "url(#paint0_linear_2188_30535)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2188_30535",
    x1: 224.48,
    y1: -32.5067,
    x2: -3.22599e-7,
    y2: 74.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F64C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F64C4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_30535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalling);
export default __webpack_public_path__ + "static/media/falling.db53b50aebcd471807222c3e807e4424.svg";
export { ForwardRef as ReactComponent };